export default __webpack_public_path__ + "static/media/9.89feb552.png";